<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Objeto
        </span>
      </h3>
    </div>
    <Form url="/objeto/create" :objeto="objeto" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import ObjetoData from "./ObjetoData";
import { mapGetters } from "vuex";

export default {
  name: "app-objeto-create",
  data() {
    return {
      objeto: new ObjetoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
